export default __webpack_public_path__ + "static/media/speaker.c6e03895.webp";